<script>
    import { Link } from "svelte-navigator";
    let active = false;
</script>
<header class:is-active={active}>
    <div class="content">
        <div class="mobile-nav-head">
            <Link to="/" id="logo">jetnoise.ch</Link>
            <button class="hamburger hamburger--spin" on:click="{() => active = !active}" class:is-active={active} type="button">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button>
        </div>
        <nav on:click="{() => active = false}" >
            <Link to="airshows">Airshows</Link>
            <Link to="galleries">Galleries</Link>
            <Link to="mychoice">MyChoice</Link>
            <Link to="about">About</Link>
        </nav>
    </div>
</header>
<style lang="scss">
    header {
        background-color: var(--background);
        height: var(--header-footer-height);
        line-height: var(--header-footer-height);
        .content {
          display: flex;
          justify-content: space-between;
        }
      .hamburger {
        display: none;
      }
        nav {
          :global(a){
            text-decoration: none;
            color: var(--font-color);
            display: inline-block;
            margin-left: var(--default-margin);
            font-size: 1.375rem;
            &:hover {
              color: var(--jetnoise-orange);
            }
          }
        }

        :global(#logo) {
          font-family: museo-slab, serif;
          font-weight: 700;
          font-style: normal;
          font-size: 1.875rem;
          text-decoration: none;
          color: var(--font-color);
          &:hover {
            color: var(--jetnoise-orange);
          }
        }
    }
    @media screen and (max-width: 800px)  {
      header {
        position: fixed;
        top:0;
        width: 100vw;
        z-index: 2;
        overflow: hidden;
        transition: height .5s ease;
        &.is-active {
          height: 100vh;
        }
        .content {
          display: block;
        }
        .mobile-nav-head {
          display: flex;
          justify-content: space-between;
        }
        .hamburger {
          padding: 6px 0;
          display: block;
        }
        nav {
          :global(a) {
            margin-left: 0;
            text-align: center;
            display: block;
          }
        }
      }
      :global(body){
        padding-top: var(--header-footer-height);
      }
    }
</style>